<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import StoreService from '@/services/StoreService'
import Tabs from '@/components/MarketplaceComponents/Tabs.vue'
import Breadcrumbs from '@/components/MarketplaceComponents/Breadcrumbs.vue'
import PageTitle from '@/components/MarketplaceComponents/PageTitle.vue'
import FormInput from '@/components/FormInput/FormInput.vue'
import AppsList from '@/components/MarketplaceComponents/AppsList.vue'
import ProductCard from '@/components/MarketplaceComponents/ProductCard'
import PageArticle from '@/components/MarketplaceComponents/PageArticle'
import qs from 'qs'
import { sendPostback } from '~/utils/utils'
import { createMeta } from '~/utils/meta'

export default {
  components: {
    PageArticle,
    AppsList,
    FormInput,
    Tabs,
    Breadcrumbs,
    PageTitle,
    ProductCard
  },

  async asyncData ({ store, $axios }) {
    await store.dispatch('marketplace/fetchApps')

    try {
      const { data } = await StoreService.getMarketplaceProductsWithUserID($axios, 1, 7, undefined, true)
      const products = data?.data?.products

      return {
        products
      }
    } catch {
      return {}
    }
  },

  data () {
    return {
      activeTabId: this.$route.query.tab || 'game',
      searchText: '',
      products: undefined
    }
  },

  computed: {
    ...mapState('user', ['user']),
    ...mapState('marketplace', ['apps', 'counters', 'currencies']),
    ...mapGetters('user', ['isAuthorized']),

    tabs () {
      return [
        {
          id: 'game',
          title: this.$t('servicesInGame')
        },
        {
          id: 'app',
          title: this.$t('applications')
        },
        {
          id: 'social',
          title: this.$t('socialNetworks')
        },
        {
          id: 'offerwall',
          title: this.$t('offerwalls')
        }
        // {
        //   id: 'subscription',
        //   title: this.$t('subscriptions')
        // }
      ]
    },

    h1Text () {
      if (this.$i18n.locale === 'ru') {
        return 'Биржа внутриигровых товаров Gaming goods'
      } else if (this.$i18n.locale.includes('en')) {
        return 'Gaming goods in-game items exchange'
      }

      return undefined
    },

    article () {
      if (this.$i18n.locale === 'ru') {
        return '<h2>Приветствуем на ru.gaming-goods.com – ваш надежный маркетплейс для покупки и продажи алмазов Free Fire</h2> <p>Ищете надежное место для покупки или продажи алмазов и других цифровых товаров для Free Fire? Мы рады приветствовать вас на ru.gaming-goods.com – лучшем маркетплейсе для геймеров, предлагающем широкий ассортимент цифровых товаров для одной из самых популярных игр мира, Free Fire.</p> <p>У нас самые низкие комиссии со сделки, лучшие условия для реферальной программы, и уникальная возможность оплаты товара - можно товар купить, можно  на него заработать, а можно его выиграть!</p> <h3>Почему стоит выбрать ru.gaming-goods.com?</h3> <h4>Высокие стандарты безопасности и гарантии</h4> <p>На нашем сайте вы можете быть уверены в безопасности своих сделок. Мы предлагаем:</p> <p><ul> <li><b>Гарантию на товар</b>: Все покупки защищены нашей гарантией, что обеспечивает вам спокойствие и безопасность. Платформа выступает как гарант, не позволяя продавцу получить средства, пока покупатель не подтвердит факт получения услуги в должном объеме.</li> <li><b>Проверенные продавцы</b>: Мы тщательно проверяем всех продавцов, чтобы обеспечить только высококачественные товары и услуги. У всех продавцов есть рейтинги и отзывы, чтобы покупатели могли выбрать лучшего для себя контрагента.</li> <li><b>Техническая поддержка</b>: наши отзывчивые и внимательные специалисты окажут вам мгновенную поддержку круглосуточно, с какой проблемой вы бы не столкнулись!</li> </ul></p> <h4>Широкий выбор цифровых товаров</h4> <p>Мы предлагаем множество товаров для Free Fire:</p> <p><ul> <li><b>Игровая валюта</b>: Алмазы Free Fire доступны в любых объемах.</li> <li><b>Аккаунты</b>: Вы можете купить или продать аккаунты Free Fire по самым выгодным ценам.</li> <li><b>Топовые скины и оружие</b>: Порадуйте себя новыми уникальными скинами и мощным оружием.</li> <li><b>Товары внутри игры</b>: будь индивидуальным и оригинальным при добавлении своих товаров! В ряде игр продавцы устраивают даже ивенты для покупателей, делая игровой процесс еще более увлекательным! </li> </ul></p> <h4>Удобный и быстрый процесс покупки</h4> <p>Мы стремимся сделать процесс покупки и продажи максимально простым и быстрым:</p> <p><ul> <li><b>Автоматическая выдача</b>: Все товары выдаются автоматически сразу после покупки.</li> <li><b>Мгновенное пополнение</b>: Быстрая и удобная система пополнения баланса и оплаты товара. Для покупки подойдут карты абсолютно любых банков мира.</li> <li><b>Комфортные условия</b>: Поддержка различных способов оплаты, включая карты и электронные кошельки.</li> </ul></p> <h3>Популярные товары для Free Fire</h3> <h4>Алмазы Free Fire</h4> <p>Алмазы Free Fire – это игровая валюта, которая позволяет вам покупать скины, оружие и другие предметы в игре. На нашем сайте вы найдете алмазы по самым выгодным ценам с мгновенной выдачей. <b>Покупайте алмазы FF дёшево и быстро.</b></p> <h4>Аккаунты Free Fire</h4> <p>Ищете топовый аккаунт с высоким уровнем и уникальными предметами? У нас вы найдете аккаунты Free Fire с полной перепривязкой и гарантией безопасности. <b>Купить аккаунт Free Fire</b> легко и удобно на ru.gaming-goods.com.</p> <h4>Топовые скины и оружие</h4> <p>Прокачайте свой игровой опыт с нашими уникальными скинами и мощным оружием. Мы предлагаем широкий выбор товаров, которые помогут вам стать лидером в игре.</p> <h3>Как начать зарабатывать на ru.gaming-goods.com</h3> <p>Мы предоставляем возможность не только покупать, но и продавать цифровые товары:</p> <p><ol> <li><b>Зарегистрируйтесь на нашем сайте</b>: Создайте аккаунт продавца и начните выставлять свои товары на продажу.</li> <li><b>Разместите свои товары</b>: Опишите ваши товары, установите цену и ожидайте покупателей.</li> <li><b>Получайте прибыль</b>: Продавайте свои товары и выводите средства быстро и удобно.</li> </ol></p> <h3>Преимущества для покупателей</h3> <p><ul> <li><b>Выгодные цены</b>: Наш маркетплейс предлагает самые конкурентоспособные цены на рынке.</li> <li><b>Широкий ассортимент</b>: Мы постоянно обновляем наш ассортимент, чтобы вы могли найти самые последние новинки и популярные товары.</li> <li><b>Бонусы и акции</b>: Участвуйте в акциях и получайте бонусы при каждой покупке.</li> </ul></p> <h3>Преимущества для продавцов</h3> <p><ul> <li><b>Большой объём трафика</b>: Ежедневно наш сайт посещают тысячи пользователей, что обеспечивает высокий спрос на ваши товары.</li> <li><b>Выгодное сотрудничество</b>: Мы предлагаем низкую комиссию за продажу и удобную систему вывода средств.</li> <li><b>Поддержка и гарантии</b>: Наша служба поддержки всегда готова помочь вам в решении любых вопросов.</li> </ul></p> <h3>Присоединяйтесь к нашему сообществу</h3> <p>На ru.gaming-goods.com вас ждет активное сообщество геймеров и продавцов. Общайтесь, находите выгодные предложения и делитесь своим опытом с другими пользователями. Подписывайтесь на наши новости и обновления, чтобы всегда быть в курсе последних акций и новинок.</p> '
      } else if (this.$i18n.locale.includes('en')) {
        return '<h2>Welcome to eu.gaming-goods.com – Your Trusted Marketplace for Digital Goods</h2> <p><b>Looking for a reliable place to buy or sell digital goods?</b> We are pleased to welcome you to <b>eu.gaming-goods.com</b> – the best marketplace for gamers, offering a wide range of digital goods, including in-game currency, accounts, and activation keys. Our Gaming Goods website provides you with a unique opportunity to buy or sell items for the most popular games such as Roblox, Mobile Legends, Valorant, Fortnite, Free Fire, Genshin Impact, and many more. On our marketplace, you can turn trading digital assets into your professional career.</p> <p>We offer the lowest transaction fees, the best conditions for referral programs, and a unique opportunity for payment options - you can buy, earn, or even win the items!</p> <h3>Why Choose eu.gaming-goods.com?</h3> <h4>High Standards of Security and Guarantees</h4> <p>On our site, you can be confident in the security of your transactions. We offer:</p> <p><ul><li><b>Product Guarantee</b>: All purchases are protected by our guarantee, ensuring your peace of mind and safety. The seller does not receive payment until the buyer confirms receipt of the goods.</li> <li><b>Verified Sellers</b>: We carefully vet all sellers to ensure only high-quality products and services. Every seller has a rating and reviews.</li> <li><b>Technical Support</b>: Our responsive and attentive specialists provide instant support around the clock, no matter the issue!</li></ul></p> <h4>Wide Selection of Digital Goods</h4> <p>We offer a vast array of products for a variety of games:</p> <ul> <li><b>In-Game Currency</b>: Robux, Gems, Gold, V-Bucks, Diamonds, and much more.</li> <li><b>Accounts</b>: You can buy or sell accounts for games such as PUBG Mobile, Fortnite, Brawl Stars, and others.</li> <li><b>Activation Keys</b>: A wide selection of keys for activating games on Steam, EA Games, Epic Games, and other platforms.</li> <li><b>In-Game Items</b>: Many players creatively add new items and services, even hosting special events in-game. Be unique and original when adding your products!</li> </ul> <h4>Convenient and Fast Purchase Process</h4> <p>We aim to make the buying and selling process on Gaming Goods as simple and fast as possible:</p> <ul> <li><b>Automatic Delivery</b>: Almost all items are delivered automatically immediately after purchase, except for services where the buyer needs to provide additional information to the seller, which can be communicated in the chat. An example of such a service could be purchasing views on Telegram, where the seller needs to know the buyer\'s account link.</li> <li><b>Instant Fund Withdrawal</b>: A fast and convenient system for sellers to withdraw funds. All bank cards worldwide and cryptocurrency wallets are available for withdrawal.</li> <li><b>Comfortable Conditions</b>: Our qualified technical support team quickly resolves any disputes and ensures fairness on the platform.</li> </ul> <h3>Popular Games and Products</h3> <h4>Roblox and Robux</h4> <p>Roblox is one of the most popular games in the world, and we offer you the opportunity to quickly and profitably buy Robux for your account. You can purchase Robux cheaply and instantly.</p> <h4>Fortnite and V-Bucks</h4> <p>For Fortnite fans, we have a wide selection of V-Bucks at competitive prices. Treat yourself to new skins and other in-game items.</p> <h4>Genshin Impact and Diamonds</h4> <p>Genshin Impact enthusiasts will find many offers for buying diamonds. Top up your balance quickly and hassle-free.</p> <h4>PUBG and Game Accounts</h4> <p>For those who want to buy a PUBG or PUBG Mobile account, our site offers verified and reliable accounts at affordable prices.</p> <h4>Mobile Legends and Activation Keys</h4> <p>Fans of Mobile Legends can purchase activation keys and game accounts at the best prices on our marketplace.</p> <h3>How to Start Earning on eu.gaming-goods.com</h3> <p>We provide the opportunity not only to buy but also to sell digital goods:</p> <ul> <li><b>Register on our site</b>: Create a seller account and start listing your items for sale.</li> <li><b>List Your Items</b>: Describe your products, set a price, and wait for buyers.</li> <li><b>Earn Profit</b>: Sell your goods and withdraw funds quickly and conveniently.</li> </ul> <h3>Benefits for Buyers</h3> <ul> <li><b>Competitive Prices</b>: Our marketplace offers the most competitive prices on the market and the lowest transaction fees.</li> <li><b>Wide Selection</b>: We constantly update our assortment so you can find the latest and most popular items.</li> <li><b>Bonuses and Promotions</b>: Participate in promotions and receive bonuses with every purchase.</li> </ul> <h3>Benefits for Sellers</h3> <ul> <li><b>High Traffic Volume</b>: Thousands of users visit our site daily, ensuring high demand for your products.</li> <li><b>Profitable Partnership</b>: We offer low sales commissions and a convenient fund withdrawal system.</li> <li><b>Support and Guarantees</b>: Our support team is always ready to help you with any issues.</li> </ul> <h3>Join Our Community</h3> <p><b>eu.gaming-goods.com</b> is a digital goods marketplace where you’ll find an active community of gamers and sellers. Connect, find great deals, and share your experiences with other users. Subscribe to our news and updates to stay informed about the latest promotions and new arrivals.</p>'
      }

      return undefined
    },

    showRub () {
      return this.$i18n.locale === 'ru'
    },

    rubCurrencyRate () {
      return this.currencies?.find(c => c.code === 'RUB')?.exchange_rate || 0
    },

    currentTabTitle () {
      return this.tabs?.find(tab => tab.id === this.activeTabId)?.title
    },

    breadcrumbs () {
      return [
        { title: this.currentTabTitle }
      ]
    },

    isSeller () {
      return this.user?.is_seller
    },

    showAddButton () {
      return [2291, 3088, 680305, 189432, 23421, 528978, 168627, 6, 20].includes(this.user?.id)
    },

    filteredApps () {
      if (!this.apps) {
        return undefined
      }

      return this.apps.filter(app => app.categories?.length || this.showAddButton).filter(app => app.app_type === this.activeTabId)
    },

    bannerBackgroundMobile () {
      return this.$i18n.locale === 'ru' ? require('@/assets/img/marketplace/banner-ru-m.webp') : require('@/assets/img/marketplace/banner-en-m.webp')
    },

    bannerBackground () {
      return this.$i18n.locale === 'ru' ? require('@/assets/img/marketplace/banner-ru-d.webp') : require('@/assets/img/marketplace/banner-en-d.webp')
    }
  },

  mounted () {
    this.fetchCounters()
    this.checkHash()
  },

  methods: {
    ...mapActions('marketplace', ['fetchCounters']),
    ...mapActions('modal', ['showModal']),
    ...mapActions('user', ['sendCid']),

    openRegistrationModal () {
      if (!this.isAuthorized) {
        this.showModal({
          component: 'Auth',
          data: {
            mode: 'register'
          }
        })
      }
    },

    async loadBestsellers () {
      const { data } = await StoreService.getMarketplaceProductsWithUserID(this.$axios, 1, 7, undefined, true)

      this.products = data?.data?.products
    },

    isFavourite (product) {
      return product?.favourite
    },

    productDescription (product) {
      if (product.short_description && product.short_description !== '') {
        return product.short_description
      }

      return product.description
    },

    maxPriceInRub (product) {
      return Math.ceil(product?.max_price / (this.rubCurrencyRate * 0.98) / 100)
    },

    addToFavourites (product) {
      if (!this.isAuthorized) {
        this.openRegistrationModal()
      } else if (this.isFavourite(product)) {
        StoreService.dropFavourite(this.$axios, product?.id)
        product.favourite = false
      } else {
        StoreService.addToFavourites(this.$axios, product?.id)
        product.favourite = true
      }
    },

    checkHash () {
      const [hash, query] = (this.$route.hash || '').split('?')

      if (
        (hash === '#registration' || 'registration' in this.$route.query) &&
        !this.user
      ) {
        this.openRegistrationModal()
      } else if (hash === '#login' && !this.user) {
        this.showModal({
          component: 'Auth',
          data: {
            mode: 'login'
          }
        })
      } else if (hash === '#social-login') {
        if (query) {
          sendPostback(this.$axios, this.$config)
        }

        this.$gtag.event('login', { account_id: this.user?.id, user_id: this.user?.id, method: 'social', is_it_a_seller: !!this.user?.is_seller, is_it_a_buyer: this.user?.is_buyer })

        this.sendCid()

        const pathBeforeAuth = window.localStorage.getItem('path-before-auth')
        if (pathBeforeAuth) {
          window.localStorage.removeItem('path-before-auth')
          this.$router.push(pathBeforeAuth)
          return
        }
      } else if (
        hash === '#payout' &&
        window.sessionStorage.getItem('payout-data')
      ) {
        const savedRoute = window.sessionStorage.getItem('payout-route')

        if (savedRoute) {
          setTimeout(() => {
            this.$router.replace(savedRoute)

            setTimeout(() => {
              this.showModal({
                component: 'PayOutModal',
                data: {
                  isComeBack: true
                }
              })
            }, 500)
          }, 500)
        }
      } else if (hash === '#reset-password') {
        this.showModal({
          component: 'ResetPassword'
        })
      } else if (hash === '#new-password' && query) {
        this.showModal({
          component: 'ResetPassword',
          data: {
            mode: 'setNewPassword',
            code: query.split('=')[1]
          }
        })
      } else if (hash === '#email-confirmed') {
        if (!this.user?.id) {
          this.showModal({
            component: 'SuccessModal',
            data: {
              icon: 'checkmark-green',
              title: this.$t('youRegistered'),
              text: this.$t('nowYouCanLoginAndLinkAccount'),
              buttons: [
                {
                  props: { isPrimary: true },
                  title: this.$t('auth'),
                  shouldClose: false,
                  action: () => {
                    this.showModal({
                      component: 'Auth',
                      data: { mode: 'login' }
                    })
                  }
                }
              ]
            }
          })
        } else {
          this.$gtag.event('click_open_modal_confirm_email_link', {})

          this.showModal({
            component: 'SuccessModal',
            data: {
              icon: 'checkmark-green',
              title: this.$t('successConfirmation'),
              text: this.$t('yourMailWasConfirmed'),
              buttons: [
                {
                  props: { isPrimary: true },
                  title: this.$t('continue'),
                  action: () => {
                    const pathBeforeAuth = window.localStorage.getItem('path-before-auth')

                    if (pathBeforeAuth) {
                      window.localStorage.removeItem('path-before-auth')
                      this.$router.push(pathBeforeAuth)
                      return
                    }

                    this.showModal({
                      component: 'Auth',
                      data: { mode: 'login' }
                    })
                  },
                  shouldClose: true
                }
              ]
            }
          })
        }
      } else if (
        hash === '#anticheat-auth' &&
        this.user?.id &&
        !this.isMobile
      ) {
        this.showModal({
          component: 'AuthAnticheat'
        })
      } else if (hash === '#overwolf-auth' && this.user?.id && !this.isMobile) {
        this.showModal({
          component: 'AuthOverwolf'
        })
      } else if (hash?.startsWith('#error=')) {
        const params = qs.parse(hash.replace('#', ''))

        try {
          params.error_data = JSON.parse(params.error_data)
        } catch (e) {
          console.error(
            `${new Date().toUTCString()} :: error data json parse error ::`,
            e
          )
        }

        const error = {
          code: Number(params.error),
          error_data: params.error_data
        }

        if (error.code === 13) {
          const message = this.$errors.getText({
            data: error
          })

          this.showModal({
            component: 'BanModal',
            data: {
              reason: message
            }
          })
        } else {
          this.$errors.handle({
            data: error
          })
        }
      }

      window.location.hash = ''
    },

    setActiveTab (tabId) {
      if (tabId === 'subscription') {
        this.$router.push('/subscriptions')
      } else if (this.tabs?.map(tab => tab.id).includes(tabId)) {
        this.activeTabId = tabId

        this.$gtag.event(`${tabId}_marketplace_click`, { account_id: this.user?.id })
      }
    },

    addNewService () {
      this.$router.push(this.localeLocation(`/marketplace/add?type=${this.activeTabId}`))
    },

    becomeSeller () {
      if (!this.isAuthorized) {
        this.openRegistrationModal()
      } else {
        this.$router.push(this.localeLocation('/marketplace/become-seller'))
      }
    }
  },

  head () {
    const meta = createMeta.call(this, {
      title: this.$t('mainPageTitle'),
      description: this.$t('indexPageMetaDescription'),
      sharingTitle: this.$t('mainPageTitle'),
      sharingDescription: this.$t('indexPageMetaSharingDesc'),
      keywords: this.$t('indexPageKeywords')
    })

    if (this.$i18n.locale === 'ru') {
      meta.meta.push({
        name: 'yandex-verification',
        content: '6f260bd207260864'
      })
    }

    meta.meta.push({
      name: 'facebook-domain-verification',
      content: 'id969hl0rj9jfid0hbjxcax08val2t'
    })

    const langHeaders = this.$nuxtI18nHead({ addSeoAttributes: true }).link

    return { ...meta, ...langHeaders }
  }
}
</script>

<template>
  <div :class="$style.page">
    <Breadcrumbs :list="breadcrumbs" />

    <div :class="$style.page__body">
      <PageTitle :title="$t('mainPageTitle')" not-h1 />

      <h1 v-if="h1Text" :class="$style.hiddenH1">
        {{ h1Text }}
      </h1>

      <Button v-if="isSeller" is-primary :class="$style.seller" @click="addNewService">
        {{ $t('createService') }}
      </Button>

      <Button v-else is-primary :class="$style.seller" @click="becomeSeller">
        {{ $t('becomeASeller') }}
      </Button>

      <div :class="$style.banner" @click="isSeller ? () => {} : becomeSeller">
        <picture :class="$style.banner__image">
          <source :srcset="bannerBackground" type="image/webp" media="(min-width: 768px)" />
          <source :srcset="bannerBackgroundMobile" type="image/webp" />
          <img :src="bannerBackgroundMobile" alt="background" />
        </picture>
      </div>

      <template v-if="products && products.length">
        <div :class="$style.bestsellers">
          <p :class="$style.bestsellers__title">
            {{ $t('bestsellersTitle') }}
          </p>
          <div v-for="product in products" :key="product.id">
            <ProductCard :class="$style.bestsellersCard" :product="product" />
          </div>
        </div>
      </template>

      <Tabs :tabs="tabs" :active-tab-id="activeTabId" @setActiveTab="setActiveTab" />

      <div :class="$style.search">
        <FormInput v-model="searchText" :placeholder="$t('search')" icon="search" />
      </div>

      <AppsList v-if="apps" :list="filteredApps" :counters="counters" :search-string="searchText" :class="$style.products" />
    </div>

    <PageArticle v-if="article" :content="article" />
  </div>
</template>

<style lang="scss" module>
.hiddenH1 {
  display: none;
}

.page {
  width: 100%;

  &__body {
    padding: 16px;
  }
}

.seller {
  width: 100% !important;
  margin-bottom: 24px;
}

.products {
  margin-top: 22px;
}

.search {
  background: $blue-grey80;
  position: sticky;
  top: 48px;
  padding: 10px 0;
  z-index: 1;

  @media (min-width: $breakpointTablet) {
    top: 78px;
  }
}

.banner {
  display: block;
  width: 100%;
  margin: 20px 0;
  border-radius: 16px;
  background-color: $blue-grey70;
  overflow: hidden;

  &__image {
    display: block;
    width: 100%;

    &Mob {
      display: block;
      width: 100%;

      @media (min-width: $breakpointTablet) {
        display: none;
      }
    }
  }
}

.bestsellers {
  @include silent-scroll;

  display: grid;
  grid-template-columns: repeat(7, 250px);
  grid-gap: 8px;
  width: 100%;
  min-width: 160px;
  margin: 20px 0;
  border-radius: 10px;
  overflow-x: auto;
  //padding-bottom: 10px;
  padding: 20px 16px;
  background: linear-gradient(262deg, #3949AB 5.62%, #5C6BC0 95.25%);

  @media (min-width: $breakpointDesktopWide) {
    grid-gap: 16px;
  }

  &Card {
    max-width: 250px;
  }

  &__title {
    width: 100%;
    color: $white;
    font-size: 24px;
    font-weight: 700;
    line-height: 32px;
    margin: 0 0 12px;
    grid-column: 1 / -1;
  }
}
</style>
